import { DEFAULT_ENGINEER_LEVEL } from "../../domainCatalog";
import { DateInput } from "./GanttControls";

const GanttEditor = ({
  humanTeam,
  selected,
  taskStudioManaged,
  workspaceView,
  onDelete,
  onUpdateEffortHours,
  onUpdateItem
}) => {
  if (!selected) return null;

  return (
    <section className="gantt-editor">
      <div className="gantt-editor-heading">
        <strong>{workspaceView ? "View epic" : "Edit epic"}</strong>
        <button onClick={onDelete} disabled={workspaceView || taskStudioManaged}>Delete epic</button>
      </div>
      <label>Title<input value={selected.title} disabled={workspaceView || taskStudioManaged} title={taskStudioManaged ? "Managed in Task Studio" : ""} onChange={(event) => onUpdateItem(selected.id, "title", event.target.value)} /></label>
      <label>Start<DateInput value={selected.start_date} onChange={(value) => onUpdateItem(selected.id, "start_date", value)} /></label>
      <label>End<DateInput value={selected.end_date} onChange={(value) => onUpdateItem(selected.id, "end_date", value)} /></label>
      <label>Progress %<input type="number" min="0" max="100" value={selected.progress} onChange={(event) => onUpdateItem(selected.id, "progress", Number(event.target.value))} /></label>
      <label>Effort hours<input type="number" min="0" value={selected.effort_hours} onChange={(event) => onUpdateEffortHours(selected.id, Number(event.target.value))} /></label>
      {selected.agent_execution_hours > 0 && <label>AI execution hours<input type="number" value={selected.agent_execution_hours} disabled /></label>}
      <label>
        Accountable engineer
        <select
          multiple
          value={selected.assignee_ids.map(String)}
          disabled={workspaceView || taskStudioManaged}
          title={taskStudioManaged ? "Managed in Task Studio" : ""}
          onChange={(event) => onUpdateItem(selected.id, "assignee_ids", Array.from(event.target.selectedOptions).map((option) => Number(option.value)))}
        >
          {humanTeam.map((member) => (
            <option key={member.id} value={member.id}>
              {member.name} · {member.level || DEFAULT_ENGINEER_LEVEL} · {member.availability_hours_per_week}h/week
            </option>
          ))}
        </select>
      </label>
      <label className="wide">Estimation reasoning<textarea rows="3" value={selected.estimation_reason || ""} onChange={(event) => onUpdateItem(selected.id, "estimation_reason", event.target.value)} /></label>
      {selected.delivery_risk && <label className="wide">Delivery status risk<input value={selected.delivery_risk} disabled /></label>}
      <label className="wide">Risk / note<input value={selected.risk} onChange={(event) => onUpdateItem(selected.id, "risk", event.target.value)} /></label>
    </section>
  );
};

export default GanttEditor;
